import JSONApiService from "@/services/JSONApiService";
import { USER_MODEL } from "@/models/user-model";
import { QUALIFICATION_MODEL } from "@/models/qualification-model";

const qualificationApi = commit => ({
  getUserQualifications: async userId =>
    JSONApiService(commit)
      .one(USER_MODEL, userId)
      .all(QUALIFICATION_MODEL)
      .get(),
  getUserBookingQualifications: async ({ userId, bookingId }) =>
    JSONApiService(commit)
      .one(USER_MODEL, userId)
      .one(QUALIFICATION_MODEL, bookingId)
      .get(),
  addUserQualification: async data =>
    JSONApiService(commit)
      .all(QUALIFICATION_MODEL)
      .post(data),
  editUserQualification: async qualification =>
    JSONApiService(commit)
      .one(QUALIFICATION_MODEL, qualification.id)
      .patch(qualification),
  removeUserQualification: async id =>
    JSONApiService(commit)
      .one(QUALIFICATION_MODEL, id)
      .destroy()
});

export default qualificationApi;
